import {
  IonButton,
  IonButtons,
  IonCard,
  IonCheckbox,
  IonCol,
  IonGrid,
  IonImg,
  IonItemDivider,
  IonLabel,
  IonRow,
  IonText,
} from '@ionic/react';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import CalendarMini from '@/assets/imgs/calendar-mini.svg';
import cardsImg from '@/assets/imgs/cards.svg';
import PaymentMini from '@/assets/imgs/payment-mini.svg';
import shopMini from '@/assets/imgs/shop-mini.svg';
import { ManagedModalRoutes } from '@/interfaces/ManagedModalInterface/ManagedModalInterface';
import { storageService } from '@/services/storage';
import { RootState } from '@/store';
import { formatPrice } from '@/utils/pricesHelper';

import styles from './CustomerAccess.module.scss';

interface CustomerAccessProps {
  nextStep: (route: ManagedModalRoutes, isEmail?: boolean) => void;
  handleLoading: (e: boolean) => void;

}

export default function CustomerAccess({
  handleLoading,
  nextStep,
}: CustomerAccessProps) {
  const customer = useSelector((state: RootState) => state.orderData.data);
  const [firstQuota, setFirstQuota] = useState<string | null>('');
  const [monthlyPayment, setMonthlyPayment] = useState<string | null>('');
  const [totalQuotas, setTotalQuotas] = useState<string | null>('');
  const [loginCookie] = useState(storageService.hasPepperMerchantLogin);

  useEffect(() => {
    if (customer) {
      // ejemplo
      setFirstQuota(formatPrice(customer?.data.cart.products[0].price));
      setMonthlyPayment(customer?.data.applicant.name);
      setTotalQuotas(customer?.data.term.toString());
    }
  }, [customer]);
  const handleContinue = async () => {
    nextStep(ManagedModalRoutes.ENTRY_MANAGED);
  };

  useEffect(() => {
    handleLoading(false);
  }, []);

  return (
    <div className={styles.customerAccessWrapper}>
      <div className={styles.orderManagedTitleDescriptionWrapper}>
        <div className={styles.orderManagedTitleWrapper}>
          <IonLabel className={styles.modalOrderManagedTitle}>¡Continúa tu compra!</IonLabel>
        </div>
        <div className={styles.orderManagedTitleWrapper}>
          <IonLabel className={styles.modalOrderManagedDescription}>
            Disfruta las ventajas de Pepper. ¡Puedes realizar tus compras hoy y pagarlas en XX cómodos plazos!
          </IonLabel>
          {' '}

        </div>
      </div>
      <div className={styles.customerAccessList}>
        <div>
          <IonCard className={styles.confirmedCustomerCard}>
            <div className={styles.customerAccessText}>
              <IonImg src={shopMini} className={styles.customerAccessImg} />
              <IonText className={styles.customerAccessOptionName}>Primera cuota</IonText>
              <IonText className={styles.customerAccessCustomerData}>{firstQuota}</IonText>
            </div>
          </IonCard>
        </div>
        <IonItemDivider className={styles.divider} />
        <div>
          <IonCard className={styles.confirmedCustomerCard}>
            <div className={styles.customerAccessText}>
              <IonImg src={PaymentMini} className={styles.customerAccessImg} />
              <IonText className={styles.customerAccessOptionName}>Pago mensual</IonText>
              <IonText className={styles.customerAccessCustomerData}>{monthlyPayment}</IonText>
            </div>
          </IonCard>
        </div>
        <IonItemDivider className={styles.divider} />
        <div>
          <IonCard className={styles.confirmedCustomerCard}>
            <div className={styles.customerAccessText}>
              <IonImg src={CalendarMini} className={styles.customerAccessImg} />
              <IonText className={styles.customerAccessOptionName}>Total de cuotas</IonText>
              <IonText className={styles.customerAccessCustomerData}>{totalQuotas}</IonText>
            </div>
          </IonCard>
        </div>
      </div>
      <IonText className={styles.descriptionText}>
        * Te enviaremos las fechas exactas de tu plan de pago al finalizar el proceso
      </IonText>
      <div className={styles.customerAccessDetail}>
        <IonLabel>DETALLE DE TU SOLICITUD</IonLabel>
        <span className={styles.infoLink} onClick={() => console.log('info')}>
          +Info
        </span>
      </div>
      <IonGrid className={styles.modalFormWrapper}>
        <IonRow className={styles.modalFormRow}>
          <IonCol>
            <div className={styles.entrySummary}>
              <div className={styles.customerAccess}>
                <IonLabel>Importe de la compra</IonLabel>
                <span className={styles.priceContainer}>
                  {12}
                  ,00€
                </span>
              </div>
              <div className={styles.additionalText}>
                <IonLabel>TIN 0,00 % | TAE 0,00 % | CA 0,00€ a abonar con la primera cuota</IonLabel>
              </div>
            </div>
          </IonCol>
        </IonRow>
      </IonGrid>
      <div className={styles.containerCards}>
        <IonText className={styles.descriptionTextCards}>Necesitarás una tarjeta de crédito o débito</IonText>
        <IonImg src={cardsImg} className={styles.customerAccessImg} />
      </div>
      <div className={classNames(styles.termsCheckbox, styles.consentCheckWrapper)}>
        <IonCheckbox mode="md" onIonChange={() => console.log(loginCookie)} checked={loginCookie} />
        <span>Acepto la </span>
        <span className={styles.termsLink} onClick={() => console.log('terms')}>
          política de privacidad y la política de cookies.
        </span>
      </div>
      <IonButtons className="next-btn-wrapper">
        <IonButton className="next-button" onClick={handleContinue} disabled={false}>Continuar</IonButton>
      </IonButtons>
    </div>
  );
}
